export class Supuesto {
  id_riesgo: number;
  id_areadelito: number;
  id_supuesto: number;
  abr: string;
  descripcion: string;
  articulado: string;
  referencia: string;
  jurisprudencia_titulo: string;
  jurisprudencia_texto: string;
  jurisprudencia_enlace: string;
  sancion_infraccion: string;
  sancion_id_tipo: any;
  sancion_riesgo_min: any;
  sancion_riesgo_max: any;
  sancion_otrasconsecuencias: any;
  sancion_disciplinaria: any;
  normativa: any = [];
  id_modulo: number;

  constructor(){
    this.id_modulo=0;
    this.id_areadelito = 0;
    this.id_riesgo = 0;
    this.id_supuesto = 0;
    this.abr = "";
    this.descripcion = "";
    this.articulado = "";
    this.referencia = "";
    this.jurisprudencia_titulo = "";
    this.jurisprudencia_texto = "";
    this.jurisprudencia_enlace = "";
    this.sancion_infraccion = "";
    this.sancion_id_tipo = "";
    this.sancion_riesgo_min = "";
    this.sancion_riesgo_max = "";
    this.sancion_otrasconsecuencias = "";
    this.sancion_disciplinaria = "";}

}



// WEBPACK FOOTER //
// ./src/app/_models/supuesto.model.ts